import { DEVICE } from '../utils/constants.json';

const INITIAL_STATE = { name: 'desktop' };
/**
 * Reducer - to update device state
 * @param {Object} state initial/default device state.
 * @param {Object} action to be performed
 * @return {Object} new device state
 */
export default function (state = INITIAL_STATE, action) {
  const { payload } = action;
  switch (action.type) {
    case DEVICE:
      return { ...payload };
    default:
      return state;
  }
}
